import React from 'react';

function Text(props) {
    const classes = props.classes || 'w-text w-text-default';
    return (
        <>
            <div class={classes}>{props.text}</div>
        </>
    );
}

export default Text;